// extracted by mini-css-extract-plugin
export default {"Alert__toast":"Alert_Alert__toast__1ccpJ","Alert__body":"Alert_Alert__body__2nYBd"};